import { useEffect } from "react";
import { TextureLoader } from "three";
import * as THREE from "three";
import { finishesData } from "./finsishesData";

export default function useSetMaterial(material, finishes) {
  const applyFinish = finishesData.find((item) => item.id === finishes);

  // console.log("useSetMaterial called with ", material, finishes,applyFinish);
  const {
    diffuseUrl,
    normalUrl,
    ormUrl,
    roughnessUrl,
    mettalicnessUrl,
    alphaURL,
    repeat,
    normalRepeat,
    ormRepeat,
    roughnessRepeat,
    mettalicnessRepeat,
    color,
    useAo,
    useRoughness,
    useMetallicness,
    useAlpha,
    roughness,
    normalScale,
    mettalicness,
    alpha,
  } = applyFinish || {};

  const loader = new TextureLoader();

  useEffect(() => {
    const textures = [];
    console.log(material,"materialmaterialmaterial",diffuseUrl, applyFinish);

    const loadTextureAsync = async (url, settings) => {
      return new Promise((resolve) => {
        loader.load(url, (texture) => {
          texture.flipY = false;
          texture.colorSpace = THREE.SRGBColorSpace;
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;
          texture.repeat.set(settings[0], settings[1]);
          textures.push(texture);
          resolve(texture);
        });
      });
    };

    const updateMaterialTextures = async () => {
      if (!material) return;

      const texturePromises = [];

      // removing any old maps on the material before addding new maps.
      material.map = null;
      material.normalMap = null;
      material.roughnessMap = null;
      material.metalnessMap = null;
      material.aoMap = null;

      if (diffuseUrl) {
        texturePromises.push(
          loadTextureAsync(diffuseUrl, repeat).then((texture) => {
            material.map = texture;
          })
        );
      }

      if (normalUrl) {
        texturePromises.push(
          loadTextureAsync(normalUrl, normalRepeat, normalScale).then(
            (texture) => {
              material.normalMap = texture;
              if (normalScale !== undefined) {
                material.normalScale.set(normalScale, normalScale);
              }
            }
          )
        );
      }

      if (roughnessUrl && useRoughness) {
        texturePromises.push(
          loadTextureAsync(roughnessUrl, roughnessRepeat).then((texture) => {
            console.log("Loaded roughness texture");
            material.roughnessMap = texture;
          })
        );
      }

      if (mettalicnessUrl && useMetallicness) {
        texturePromises.push(
          loadTextureAsync(mettalicnessUrl, mettalicnessRepeat).then(
            (texture) => {
              material.metalnessMap = texture;
            }
          )
        );
      }

      if (alphaURL && useAlpha) {
        texturePromises.push(
          loadTextureAsync(alphaURL, repeat).then(
            (texture) => {
              material.alphaMap = texture;
            }
          )
        );
      }

      if (ormUrl && (useAo || useRoughness || useMetallicness)) {
        texturePromises.push(
          loadTextureAsync(ormUrl, ormRepeat).then((texture) => {
            if (useAo) material.aoMap = texture;
            if (useRoughness) material.roughnessMap = texture;
            if (useMetallicness) material.metalnessMap = texture;
          })
        );
      }

      if (color) {
        material.color.set(color);
      }
      if (roughness !== undefined) {
        material.roughness = roughness;
      }
      if (mettalicness !== undefined) {
        material.metalness = mettalicness;
      }
      if (alpha !== undefined) {
        material.opacity = alpha;
      }

      await Promise.all(texturePromises);

      material.needsUpdate = true;
      // console.log(
      //   "MaterialSet on ",
      //   material.name,
      //   "\nDiffuse map: ",
      //   material.map,
      //   "\nNormal map: ",
      //   material.normalMap,
      //   "\nNormal scale: ",
      //   material.normalScale,
      //   "\nRoughness map: ",
      //   material.roughnessMap,
      //   "\nRoughness: ",
      //   material.roughness,
      //   "\nMetalness map: ",
      //   material.metalnessMap,
      //   "\nMetalness: ",
      //   material.metalness,
      //   "\nAO map: ",
      //   material.aoMap,
      //   "\nColor: ",
      //   material.color
      // );
    };

    updateMaterialTextures();

    // Cleanup function
    return () => {
      textures.forEach((texture) => {
        texture.dispose(); // Dispose of each texture
      });
    };
  }, [
    material,
    diffuseUrl,
    normalUrl,
    ormUrl,
    roughnessUrl,
    mettalicnessUrl,
    repeat,
    normalRepeat,
    ormRepeat,
    roughnessRepeat,
    mettalicnessRepeat,
    color,
    useAo,
    useRoughness,
    useMetallicness,
    roughness,
    normalScale,
    mettalicness,
  ]);

  return loader;
}

//  useSetMaterial;
